<template>
  <SkeletonBlock
    :is-active="isSkeletonActive"
    :width="params.width"
    :height="params.height"
  >
    <slot />
  </SkeletonBlock>
</template>
<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  import { useListingSkeleton } from '@/shared/composables/useDelayedListingSkeleton.ts';

  const { isMobile, isTablet } = useScreenSize();

  const params = computed(() => {
    if (isMobile.value || isTablet.value) {
      return {
        width: 140,
        height: 14,
      };
    }

    return {
      width: 162,
      height: 16,
    };
  });

  const { isSkeletonActive } = useListingSkeleton();
</script>
